var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "url(#pattern0_173_642)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_173_642",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_173_642",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_173_642",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD/ElEQVR4nO2cS2sTURSAP5HUdONaKyqULgqiVYsuBMVFf4dutULpxkc3PhYulKpYBbtwrSBYBfUn+MAHWhVcuRJR1NRXEbXSkQM3EEKmaWbu3MfkfHA2Jbm598vpzH2cCSiKoiiKoiiKoiiKoihCDzAKPATmgaSkMQ88AA4CFddf/VrgaQASEsfxGFjjMpO7UXLSINtJZh8KYLCJ5zjgQvSjAAaaeA65ZhfOzwAGmniOHy5Ep324vt4yKpolE0tFO0oUa2hGo6KTAO4Z1tCMxq/obovC8T3AJJBQ0ahofGehZjT+xemlA/9Sg7pGl5VERbtBRTtCRTtCRTtCRTsiGtG9wEXgY4YplLznPFDFH9GIvmRhzipflC+iEL0CqFkQPWfa8kEUooUvFkTLl6Wi24iesiBa2vBFNBldBc4BHzIIlvdcMDdUX0QjOnZGgDFgGnihot2xwVXtXbdltDdUtCNUtCNUdMSie3Psh9RjETjewcJmJbALOAXcAt6YFejfhtXoK+A6MG5eK087RC36cs4FzT9g3zI/axNwNePWwCdgEhgkQtErTPbkyeT9y/iczcA98/rEQtwEBogso+dyDHiiTduyMj3dcEmwGX+AM0VdUooQfSnjQK+1aXc9MFuA4OaQ53o2EoHoaob9kLfA6iXa3A68dyC5HrJLOUzgom0zlPNylDW+Aju6RfQA8NmD5HrIbKa/7KKrwDOPkuvxBFhVZtHnApBcD+lLKUVvAxYCEFyPhbwLm1BF3w1AbnPcdim618I+Rj3kNzNasdXCik8WH0eAPhNHzd/y9nkoprqOxIScbhR1ACximznmsybFR11HYlZ4raiYzZ687UsWN9Nnod3PWZfonWZ0zZJoORxtxV5L7Xc63k5itwvRU5Y6KyfRrTgcgegjodd1JA0hx/6tuBGB6BkXoovmdQSi0+4vUYn+HoHod2UQ/S8C0b+yDExF07Ho32UQ/S2CjJa5dPSiX0UgWm7Y0fwc20hKf65HIFpOzDvmoSfRYyn9GY9A9Iksokc9iZ5O6c+uCETvySK6Yn4I1bXo2ZT+9BS4qbTOQru1PHUfazzJ3pDSn0kLbcuWaDMTFtq9Qk4qpvL9vsMb5MGUvgxaaPuPkd1nMnnCwsb/ojliKxUzHv7D2sUdSki/WYElAR3OZj7GCp2zAQi2Vm4QMhVzz/At+aXnZyOdsNHSY9FZ41PRddMhMeypyFFmXzvpMrZbPBhebiZ3neTGmYiLhdXzbrpcpNFjZgBF1OUtmLZ9/kJOcAyaWjgbghdNrd8W34MKmSFTppWlWL1m9i5Kt6ymQOSSIhVEUtwiD3TK7qCcVstBquxxyBRRTm9k0/6k2erM/PTVfxmw/WL/yYojAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayDate);
export default __webpack_public_path__ + "static/media/PayDate.fd7c4c04222d1ac28ccf6d7ece0914a9.svg";
export { ForwardRef as ReactComponent };